/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeSyncEndpointRequest
 */
export interface TimeSyncEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof TimeSyncEndpointRequest
     */
    server: string;
}

export function TimeSyncEndpointRequestFromJSON(json: any): TimeSyncEndpointRequest {
    return TimeSyncEndpointRequestFromJSONTyped(json, false);
}

export function TimeSyncEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeSyncEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'server': json['server'],
    };
}

export function TimeSyncEndpointRequestToJSON(value?: TimeSyncEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'server': value.server,
    };
}


